(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["loading-animation"] && !Shopify.designMode) return;
  try {
    (function() {
    var STORAGE_KEY = 'arx_loading_shown';
    var overlay = document.getElementById('LoadingOverlay');
    if (!overlay) return;

    // Skip if already shown this session
    if (sessionStorage.getItem(STORAGE_KEY)) {
      overlay.classList.add('is-skipped');
      return;
    }

    // Mark as shown
    sessionStorage.setItem(STORAGE_KEY, '1');

    // Prevent scrolling during animation
    document.body.style.overflow = 'hidden';

    // Hide overlay after animation completes
    var duration = 2000;
    setTimeout(function() {
      overlay.classList.add('is-hidden');
      document.body.style.overflow = '';
    }, duration);

    // Remove from DOM after fade out
    overlay.addEventListener('transitionend', function handler(e) {
      if (e.propertyName === 'opacity') {
        overlay.removeEventListener('transitionend', handler);
        overlay.remove();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
